import React from 'react';
import styles from './MensajeGrabando.module.css';

/**
 * Componente para mostrar mensaje de grabando con spinner animado
 * Props:
 * - isGrabando: boolean - si se está grabando
 * - entidad: string - tipo de entidad que se está grabando (ej: "partido", "torneo", "club")
 * - plural: boolean - si el mensaje debe estar en plural ("Grabando partidos...")
 * - estilo: string - clase CSS adicional
 * - mensaje: string - mensaje personalizado completo (sobrescribe entidad y plural)
 */
const MensajeGrabando = (props) => {
  const estiloAdicional = props.estilo;
  const isGrabando = props.isGrabando;
  const entidad = props.entidad || '';
  const plural = props.plural || false;
  const mensajePersonalizado = props.mensaje;

  // Si hay mensaje personalizado, usarlo; sino construir con entidad
  let mensaje = mensajePersonalizado;
  if (!mensaje) {
    if (entidad) {
      mensaje = `Grabando ${entidad}${plural ? 's' : ''}...`;
    } else {
      mensaje = 'Grabando...';
    }
  }

  return (
    <React.Fragment>
      {isGrabando && (
        <div className={`${styles.grabando} ${estiloAdicional || ''}`}>
          <span className={styles.spinner}>⟳</span> {mensaje}
        </div>
      )}
    </React.Fragment>
  );
};

export default MensajeGrabando;
